/**
 * 筛选图标
 */

const FilterIcon = ({ color = '#0F0F0F' }) => {
  return (
    <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M2 3L5.8 8.60593V13L9.2 14V8.60593L13 3H2Z"
        stroke={color}
        strokeWidth="1.4"
        strokeLinejoin="bevel"
      />
    </svg>
  )
}

export default FilterIcon
